import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import type { Route } from 'next';
import Breadcrumbs from 'components/Breadcrumbs';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Benefits/Support/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  const { width: screenWidth } = useWindowSize(); 

  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Benefits', href: '/benefits' as Route },
            { title: 'Support', href: '' as Route },
          ]}
        />
        <div className={cn('header__content')}>
          <div className={cn('header__title-box')}>
            <h1 className={cn('header__title')}>
              <span>Support Services for</span> 
              <span>DF Alliance Members</span>
            </h1>
            {screenWidth >= 769 
              ?
              <p className={cn('header__title-description')}>
                <span>Empowering logistics businesses with 24/7 guidance, personalised solutions, and</span>
                <span>proactive problem-solving to keep you moving forward seamlessly.</span>
              </p>
              :
              <p className={cn('header__title-description')}>
                Empowering logistics businesses with 24/7 guidance, personalised solutions, 
                and proactive problem-solving to keep you moving forward seamlessly.
              </p>
            }
          </div>
          <div className={cn('header__buttons')}>
            <Link className={cn('header__button-discover')} href="#benefits-cards">
              Discover DFA Support
            </Link>
            {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
            {/* <Link className={cn('header__button-join')} href="/membership">
              Join DFA Today
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7" />
                <path d="M2 1l4 4-4 4" />
              </svg>
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;